<template>
    <section>
        <component :is="pageCountry"></component>
    </section>
</template>
<script>
import CadastroTerritorio from './CadastroTerritorio.vue';
import CadastroTerritorioAr from './CadastroTerritorioAr.vue';
import { mapState } from 'vuex';

export default {
    components: {
        CadastroTerritorioAr,
        CadastroTerritorio
    },
    computed: {
        ...mapState(['usuarioLogado']),

        pageCountry() {
            switch (this.usuarioLogado.ambienteLogado) {
                case 'AR':
                    return CadastroTerritorioAr;

                default:
                    return CadastroTerritorio;
            }
        }
    }
};
</script>
